import { alpha, useTheme } from '@mui/material';

import { AvatarContainerStyled, PersonOutlinedIconStyled } from './styles/AvatarComponentStyles';
import { PlatformAltTexts } from '../../../constants/PlatformAltTexts';
import useGetPaletteFromWhiteLabel from '../../../hooks/useGetPaletteFromWhiteLabel';
import palette from '../../../theme/learnerPalette';
import AtomAvatar from '../../atoms/AtomAvatar/AtomAvatar';

interface IAvatarProps {
  size: number;
  src?: string;
  nameInitials?: string;
}

const AvatarComponent: React.FC<IAvatarProps> = ({ size, src, nameInitials }) => {
  const theme = useTheme();
  const wlPalette = useGetPaletteFromWhiteLabel();
  const backgroundColorPalette = wlPalette?.background.redViolet ?? palette.light.background.redViolet;
  const colorPalette = wlPalette ? wlPalette.text.redViolet : palette.light.text.redViolet;

  return (
    <AvatarContainerStyled>
      <AtomAvatar
        alt={PlatformAltTexts.profile.title}
        src={src}
        sx={{
          width: size,
          height: size,
          fontSize: `${size * 0.4}px`,
          color: colorPalette,
          background: alpha(backgroundColorPalette, 0.24),
          [theme.breakpoints.down('sm')]: {
            width: size * 0.75,
            height: size * 0.75,
            fontSize: `${size * 0.28}px`,
          },
        }}
      >
        {!src && !nameInitials ? <PersonOutlinedIconStyled size={size} /> : <p>{nameInitials}</p>}
      </AtomAvatar>
    </AvatarContainerStyled>
  );
};

export default AvatarComponent;
